import type { ValueFormatterParams } from 'ag-grid-community';
import { baseColumn } from './baseColumn';
import type { ColDefFactory, Column } from './types';
import { displayNameComparator } from './utils';
export const customer: ColDefFactory<Column> = column => ({
  ...baseColumn(column),

  valueFormatter: ({ value, context }: ValueFormatterParams<unknown, any>) => {
    if (!value) {
      return '';
    }
    return context.current.customersByName?.get(value)?.DisplayName || value;
  },
  sortingOrder: ['asc', 'desc'],
  comparator: (valueA, valueB, nodeA) => displayNameComparator(valueA, valueB, nodeA, ['customersByName']),
});
